import * as Sentry from '@sentry/react';

const getException = (event: Sentry.Event) => {
    const { exception } = event;
    if (exception) {
        const { values } = exception;
        if (Array.isArray(values) && values.length > 0) {
            return values[0];
        }
    }

    return null;
};

export default getException;
